import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';
import { Binary } from '@angular/compiler';

export interface StockTransferParameter extends Parameter {
    searchTerm: number;
    orderBy: string;

}

export interface StockTransfer {

}


export abstract class StockTransferData {

    abstract list(url: string): Observable<StockTransfer[]>;
    abstract getById(url: string): Observable<any>;
    abstract create(url: string, data: StockTransfer): Observable<StockTransfer[]>;
    abstract update(url: string, data: StockTransfer): Observable<StockTransfer>;
    abstract delete(url: string): Observable<any>;
    abstract searchList(url: string,data:any): Observable<any>;
}
